import type { BaseKeyFunction } from "../../../lib";

export type KeySectionProps = { id: string };

export const keySection: BaseKeyFunction<KeySectionProps> = ({ id }) => [
  "sections",
  id,
];
